/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/CampaignFormFields.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const CampaignFormFieldsTestIds = {
  campaignComboboxOwner: "campaign-combobox-owner",
  campaignInputDescription: "campaign-input-description",
  campaignInputDueDate: "campaign-input-due-date",
  campaignInputName: "campaign-input-name"
} as const;
